import { render } from "./AddPaymentMethod.vue?vue&type=template&id=351d4c9c"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__